/* eslint-disable react/no-danger */
import type { ThemeKey, DefaultThemeStyles } from 'Src/types/theme';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { themes } from 'Components/frameworks/text/Text.themes';
type Props = {
  children: string;
  className?: string;
  theme?: ThemeKey<typeof themes>;
};
export const TextHtml = ({ children, className, theme = 'text-sans-n1' }: Props) => {
  if (!children) {
    return null;
  }

  const { thRoot } = themes[theme] as DefaultThemeStyles<typeof themes>;
  return (
    <div
      className={classnames(thRoot, className)}
      dangerouslySetInnerHTML={{
        __html: children,
      }}
    />
  );
};
